import { MapPin, MessageCircle, Navigation, Phone, Tag } from "lucide-react";

const mapUrl = (r) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${r.name}, ${r.address}, ${r.zip} ${r.city}`)}`;

function Contact({ r }) {
  if (r.whatsapp) {
    return (
      <a href={`https://wa.me/${r.whatsapp}`} target="_blank" rel="noopener noreferrer" data-testid={`reseller-whatsapp-${r.id}`}
        className="inline-flex items-center gap-1.5 rounded-full bg-[#1F7A4D] px-4 py-2 text-xs font-semibold text-white hover:bg-[#186440]">
        <MessageCircle className="h-3.5 w-3.5" />WhatsApp {r.phone}
      </a>
    );
  }
  const tel = r.phone.startsWith("+") ? `+${r.phone.replace(/\D/g, "")}` : r.phone.replace(/\D/g, "");
  if (tel.length === 10 || tel.startsWith("+")) {
    return (
      <a href={`tel:${tel}`} data-testid={`reseller-phone-${r.id}`} className="inline-flex items-center gap-1.5 rounded-full bg-[#141013] px-4 py-2 text-xs font-semibold text-[#FBF8F3] hover:bg-[#3A2A20]">
        <Phone className="h-3.5 w-3.5" />{r.phone}
      </a>
    );
  }
  return r.phone ? <span className="rounded-full border border-[#E3D5C3] px-4 py-2 text-xs text-[#5E544D]">{r.phone}</span> : null;
}

export function ResellerCard({ r }) {
  return (
    <li data-testid={`reseller-${r.id}`} className={`flex flex-col rounded-2xl border p-5 transition-[border-color,transform] duration-300 hover:-translate-y-0.5 ${r.featured ? "border-2 border-[#B8893A] bg-[#FFF9EE]" : "border-[#E3D5C3] bg-white hover:border-[#B8893A]"}`}>
      {r.offer ? <p data-testid={`reseller-offer-${r.id}`} className="mb-3 inline-flex w-fit items-center gap-1.5 rounded-full bg-[#4A1942] px-3 py-1 text-xs font-semibold text-[#F1DBA6]"><Tag className="h-3.5 w-3.5" />{r.offer}</p> : null}
      <h3 className="font-display text-xl leading-snug text-[#141013]">{r.name}</h3>
      <p className="mt-3 flex gap-2 text-sm leading-relaxed text-[#5E544D]">
        <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#7A5418]" />
        <span>{r.address ? <>{r.address}<br /></> : null}{r.zip} {r.city}</span>
      </p>
      {r.note ? <p className="mt-2 text-sm font-semibold text-[#141013]">{r.note}</p> : null}
      <div className="mt-auto flex flex-wrap gap-2 pt-4">
        {r.phone.split("/").map((p, i) => <Contact key={p} r={{ ...r, phone: p.trim(), id: i ? `${r.id}-${i + 1}` : r.id }} />)}
        {r.address ? (
          <a href={mapUrl(r)} target="_blank" rel="noopener noreferrer" data-testid={`reseller-map-${r.id}`} className="inline-flex items-center gap-1.5 rounded-full border border-[#141013] px-4 py-2 text-xs font-semibold text-[#141013] hover:bg-[#141013] hover:text-[#FBF8F3]">
            <Navigation className="h-3.5 w-3.5" />Itinéraire
          </a>
        ) : null}
      </div>
    </li>
  );
}
